import { QC_CONFIRM, POST } from "../../../services/index";

export const useQc = () => {
  const onConfirm = async (device: string) => {
    try {
      await POST(QC_CONFIRM, { deviceID: device });
      return true;
    } catch (error: any) {
      console.log(error);
      return false;
    }
  };
  return {
    onConfirm,
  };
};
